import {ACTION_EVENTS} from "../../UserAction";
import {ELEMENT_IDS} from "../MobileDOM";
import IMadmaxMessage from "../../messages/IMadmaxMessage";

export default class SoundOnOff implements IMadmaxMessage {
    id: number;
    priority: number;
    isActive: boolean;

    public wrapper: HTMLElement;
    private _visible: boolean;

    constructor() {
        this.create();
    }

    create() {
        let wrapper = document.createElement("div");
        wrapper.classList.add("mx-sound-choose-box");
        wrapper.id = ELEMENT_IDS.SOUNDONOFF;
        this.wrapper = wrapper;
        // parent.appendChild(wrapper);

        let buttonsWrapper = document.createElement("div");
        buttonsWrapper.classList.add("mx-sound-choose-box-wrap");
        wrapper.appendChild(buttonsWrapper);

        let buttonOn = document.createElement("button");
        buttonOn.classList.add("mx-button", "mx-input", "mx-sound-choose-button", "mx-sound-choose-on", "mx-ico-sound-on");
        $(buttonOn).data("action", ACTION_EVENTS.ACTION_SOUND_CHOOSE);
        $(buttonOn).data("data", "on");
        buttonsWrapper.appendChild(buttonOn);

        let buttonOff = document.createElement("button");
        buttonOff.classList.add("mx-button", "mx-input", "mx-sound-choose-button", "mx-sound-choose-off", "mx-ico-sound-off");
        $(buttonOff).data("action", ACTION_EVENTS.ACTION_SOUND_CHOOSE);
        $(buttonOff).data("data", "off");
        buttonsWrapper.appendChild(buttonOff);

        this.closeMessage();

    }

    openMessage() {
        $(this.wrapper).show();
        this._visible = true;
        // events.dispatch(UIMESSAGES_EVENTS.UIMESSAGE_OPEN);
    }

    show() {

    }

    closeMessage() {
        $(this.wrapper).hide();
        this._visible = false;
        // events.dispatch(UIMESSAGES_EVENTS.UIMESSAGE_CLOSE);
    }

    hide() {

    }

    getElement() {
        return this.wrapper;
    }

    isMessageOpened(): boolean {
        return this._visible;
    }

    setOnClose(f: Function) {}

    unsetOnClose() {}
}